import React, { useState } from 'react';
import { Dialog, DialogContent, TextField, Button, Typography } from '@mui/material';
import './ForgotPasswordStyles.css';

export default function VerifyCode({ open, onClose, onSubmit, onResendCode, email }) {
    const [code, setCode] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!code) {
            setError('Please enter the verification code');
            return;
        }
        try {
            await onSubmit(code);
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth="sm" 
            fullWidth
            PaperProps={{
                sx: {
                    width: '100%',
                    maxWidth: '444px', // Match sign in dialog width
                    margin: '20px'
                }
            }}
        >
            <DialogContent className="forgot-password-dialog">
                <Typography className="forgot-password-title">
                    Enter Verification Code
                </Typography>
                <Typography className="forgot-password-subtitle">
                    We've sent a code to {email}. Enter it below to verify your email.
                </Typography>
                <form onSubmit={handleSubmit}>
                    <TextField
                        className="forgot-password-input verification-code-input"
                        label="Verification Code"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        error={!!error}
                        helperText={error}
                        required
                    />
                    <Button
                        type="submit"
                        className="forgot-password-button"
                    >
                        Verify Code
                    </Button>
                    <Typography
                        className="forgot-password-link"
                        onClick={onResendCode}
                    >
                        Didn't receive the code? Click to resend
                    </Typography>
                </form>
            </DialogContent>
        </Dialog>
    );
} 